import React from 'react';
import Resource from '../../../common/Resource'
import Panel from '../../../common/layout/Panel'

export default class  extends React.Component {
    render () {
        var accountId = this.props.match.params.account_id;
        const data = {
            url: `/admin/clients/accounts/${accountId}/smsdids`,
            data: {
                data: [],
                metadata: []
            },
            loading: false,
            metadata:
                [
                    {
                        'label': 'id',
                        'source': 'ATRSMSDIDID',
                        'type': 'primary',
                        'editable': false,
                        'visible': false
                    },
                    {
                        'label': 'DID number',
                        'source': 'ATRDIDNUMBER',
                        'type_edit': 'text',
                        'type_add': 'select',
                        'editable': false,
                        'visible': true,
                        'default' : {
                            'type': 'uri',
                            'data': `/admin/clients/accounts/${accountId}/smsdids/available`,
                            'params': {}
                        },
                        'placeholder': 'select...'
                    },
                    {
                        'label': 'Mapping Type',
                        'source': 'ATRMAPPINGTYPE',
                        'type': 'select',
                        'default': 'none',
                        'editable': true,
                        'visible': true
                    },
                    {
                        'label': 'SMPP Account',
                        'source': 'ATRMAPPINGSMPPACCOUNT',
                        'type': 'select',
                        'editable': true,
                        'visible': true
                    },
                    {
                        'label': 'SMS MO Webhook',
                        'source': 'client_sms_mo_webhook_id',
                        'type': 'select',
                        'editable': true,
                        'visible': true
                    },
                    {
                        'label': 'MMS MO Webhook',
                        'source': 'client_mms_mo_webhook_id',
                        'type': 'select',
                        'editable': true,
                        'visible': true
                    },
                    {
                        'label': 'Enabled',
                        'source': 'ATRSTATUS',
                        'type': 'checkbox',
                        'editable': true,
                        'visible': true,
                        'default' : true
                    },
                    {
                        'label' : 'Actions',
                        'type': 'action_buttons'
                    }
                ]
            }
            
        return (
            <Panel title = "SMS DIDs">
                <Resource
                    addButtonText = "Add SMS DID Number"                    
                    data = {data}
                    {...this.props} 
                />
            </Panel>
        )
    }
}
